import React, { useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import { Grid, Typography } from "@material-ui/core";
import roleService from "./roleService";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import DefaultChip from "../../componentes/chip/DefaultChip";



const columnsRoles = (t) => [
    {
        field: "id",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="id" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="primary"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.id}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "description",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="role" name="profile" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.description}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "permissionType",
        visible: false,
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        template: (props) => {
            return (
                <>
                    {props.status === 1 ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export default function Role() {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    function reducer(state, action) {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialRoleState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const initialRoleState = {
        id: 0,
        description: "",
        idUser: userId,
        permissionType: 0,
        status: 1,
        roleRows: [],
        alertMessage: "",
        success: false,
        error: false
    };

    const [role, dispatch] = useReducer(reducer, initialRoleState);
    const {permissionType, description, alertMessage, success, error, roleRows, status } = role

    const handleChange = ({ target: { name, value } }) => {
        dispatch({
            type: 'update',
            data: { [name]: value }
        })
    }

    const searchRole = () => {
        const {
            roleRows,
            alertMessage,
            success,
            error,
            ...data
        } = role;
        roleService
            .get(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({
                        type: 'update',
                        data: { roleRows: response.data }
                    })
                }
            })
            .catch((e) => dispatch({
                type: 'update',
                data: { roleRows: [] }
            }));
    };

    const canSave = () => {
        if (role.description === '' || role.permissionType === 0){
            return false;
            
        }
        return true;
    }

    const saveRole = () => {
        dispatch({
            type: 'update',
            data: { alertMessage: "" }
        })
        if (canSave()) {
            if (role.id === 0) {
                let data = { ...role };

                let currentdate = new Date();
                let datetime =
                    currentdate.getDate() +
                    "/" +
                    (currentdate.getMonth() + 1) +
                    "/" +
                    currentdate.getFullYear() +
                    " " +
                    currentdate.getHours() +
                    ":" +
                    currentdate.getMinutes() +
                    ":" +
                    currentdate.getSeconds();

                data.registerDate = datetime;

                roleService
                    .create(data)
                    .then((response) => {
                        if (response.status === 200 && response.data.id > 0) {
                            dispatch({ type: 'success' })
                            searchRole();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            } else {
                roleService
                    .update(role)
                    .then((response) => {
                        if (response.status === 200 && response.data.id > 0) {
                            dispatch({ type: 'success' })
                            searchRole();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({
                type: 'update',
                data: { alertMessage: t("checkFields"), error: true, success: false }
            })
        }
    };

    const selectedRoleChanged = (data) => {
        dispatch({
            type: 'update',
            data: { idUser: userId, ...data, }
        })
    };

    return (
        <>
            <DefaultScreenAccordion
                title={"role"}
                isRegister
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            message={alertMessage}
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <GridInputRow>
                            <Grid item xs={12} sm={6} md={4}>
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="description" labelName="description" />
                                    }
                                    name="description"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={description}
                                    length={50}
                                    error={error && description === ""}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <DefaultAutocomplete
                                    name={"permissionType"}
                                    onChange={handleChange}
                                    value={permissionType}
                                    label={t("permissionType")}
                                    defaultSize
                                    useApi
                                    endpoint="GetPermissionTypeAutoComplete"
                                    error={error && permissionType === 0}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <DefaultAutocomplete
                                    name={"status"}
                                    onChange={handleChange}
                                    value={status}
                                    label={t("status")}
                                    defaultSize
                                    items={[
                                        { id: 0, name: t("canceled"), status: 1 },
                                        {id: 1, name: t("active"), status: 1},
                                        {id: 2, name: t("all"), status: 1},
                                    ]}
                                />
                            </Grid>

                        </GridInputRow>
                        <SearchClearSaveRow
                            onClickSearch={searchRole}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            onClickSave={saveRole}
                        />
                    </GridItemContainer>
                } />


            {roleRows.length > 0 ? (
                <DefaultScreenAccordion
                    title={"roleGrid"}
                    isRegister
                    fields={
                        <DefaultDatagrid
                            dataSource={roleRows}
                            columns={columnsRoles(t)}
                            allowPaging={true}
                            cellSelected={(selected) => {
                                selectedRoleChanged(selected.data);
                            }}
                        />
                    } />
            ) : null}
        </>
    );
};
